module.exports = __webpack_public_path__ + "img/featureback3.c3e8900f.png";